import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ExpertiseTable from "../../components/ExpertiseTable";

const items = [
  {
    label: "Управление ООП",
    link: "#"
  },
  {
    label: "Ресурсы",
    link: "/work/app/manage/resources"
  },
  {
    label: "Образовательные программы и модули",
    link: "/work/app/manage/resources/programs"
  },
  {
    label: "Управление экспертизой и публикацией",
    link: "/work/app/manage/resources/programs/expertise"
  },
];

const ExpertiseList = () => {
  return (
    <div>
      <Breadcrumbs items={items} />
      <ExpertiseTable/>
    </div>
  );
};

export default ExpertiseList;
